import { FC } from "react";
import { NavLink } from "react-router-dom";

import { ImageGridItemProps } from "./ImageGridItem.type";

// `group` is what enables the image's hover treatment in ImageGridBlock. It is applied only
// here, so grid items without a URL — the IRHMA photos, the icon grids — stay inert rather
// than promising an interaction that does not exist.
const linkClassName =
	"group flex flex-col items-center rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary";

const ImageGridItem: FC<ImageGridItemProps> = ({ children, item }) => {
	if (typeof item.url === "string") {
		if (item?.isInternalUrl) {
			return (
				<NavLink className={linkClassName} title={item?.imageAlt ?? ""} to={item.url}>
					{children}
				</NavLink>
			);
		}

		return (
			<a className={linkClassName} href={item.url} title={item?.imageAlt ?? ""} target="_blank" rel="noreferrer">
				{children}
			</a>
		);
	}

	return <>{children}</>;
};

export { ImageGridItem };
